module.exports = __webpack_public_path__ + "static/img/2.c059864.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/2.png
// module id = K2Bj
// module chunks = 0